import React, {useCallback, useMemo, useState} from "react";
import "./index.scss";
import {connect} from "react-redux";
import {startThreadsLeaderboardsGet} from "features/pages/threads/leaderboards/reducer";
import {threadsLeaderboardsData} from "features/pages/threads/leaderboards/selectors";
import {Icon} from "features/components/icon";
import Title from "features/components/title";
import {__} from "services/i18n";
import Text from "features/components/text";
import {THREAD_LEADERBOARDS_CAROUSEL_TIMING} from "constants.js";
import {generateFullUrl} from "services/utils/utils";
import {ModalPortal} from "features/components/modal";
import Button from "features/components/button";

/* istanbul ignore next */
const mapStateToProps = state => ({
    data: threadsLeaderboardsData(state)
});
/* istanbul ignore next */
const mapDispatchToProps = {
    startThreadsLeaderboardsGet
};

export const ThreadLeaderboards = (props) => {

    const {data} = props;
    const {startThreadsLeaderboardsGet} = props;

    const [index, setIndex] = useState(0);

    React.useEffect(() => {
        startThreadsLeaderboardsGet();
    }, [startThreadsLeaderboardsGet]);

    const categoryList = useMemo(() => {
        return data.map(i => i.name);
    }, [data]);

    const renderChips = useMemo(() => {
        return <div className={"chips"}>
            {categoryList.map((i, itemIndex) => <div onClick={() => setIndex(itemIndex)} className={`${index === itemIndex ? "selected" : ""}`} key={i}>
                <Title size={12}>{i}</Title>
            </div>)}
        </div>
    }, [categoryList, index]);

    const selectedCategory = useMemo(() => {
        return data[index];
    }, [data, index])

    const goBack = useCallback(() => {
        setIndex(index === 0 ? data.length - 1 : index - 1);
    }, [data, index]);
    const goForth = useCallback(() => {
        setIndex(index === data.length - 1 ? 0 : index + 1);
    }, [data, index]);

    /*istanbul ignore next*/
    React.useEffect(() => {
        const interval = setInterval(() => {
            goForth()
        }, THREAD_LEADERBOARDS_CAROUSEL_TIMING);
        return () => clearInterval(interval);
    }, [goForth, index]);

    const renderContent = useMemo(() => {
        if(!selectedCategory) return null;
        return <div className={"white-box leaderboard"}>
            <div className={"controls"}>
                <div onClick={goBack}><Icon>chevron-left</Icon></div>
                <Title size={24} align={"center"}>{selectedCategory.name}</Title>
                <div onClick={goForth}><Icon>chevron-right</Icon></div>
            </div>
            <div className={"users"}>
                {selectedCategory.chart.map(item => <div key={item.id}>
                    {!!item.avatar ? <img src={generateFullUrl(item.avatar)} alt="author avatar"/> : <div className="default"><Icon>account-circle</Icon></div>}
                    <Title size={16}>{item.name}</Title>
                    <Text size={12}>{__(`thread-leaderboards.messages.${item.comments === 1 ? "single" : "plural"}`, [{key: "[count]", value: item.comments}])}, {__(`thread-leaderboards.best-answers.${item.best_answers === 1 ? "single" : "plural"}`, [{key: "[count]", value: item.best_answers}])}</Text>
                </div>)}
            </div>
        </div>
    }, [goBack, goForth, selectedCategory])
    const [showHowModal, setShowHowModal] = useState(false);

    const renderHowModal = useMemo(() => {
        if(!showHowModal) return null;
        return <ModalPortal className={"leaderboard-how-to-modal"}>
            <Title size={34}>{__("thread-leaderboards.modal.title")}</Title>
            <Text size={16}>{__("thread-leaderboards.modal.text")}</Text>
            <Button title={__("buttons.ok-close")} onClick={() => setShowHowModal(false)} />
        </ModalPortal>
    }, [showHowModal]);


    return <div className={"thread-leaderboards"}>
        <Icon>diamond</Icon>
        <Title size={28} align={"center"}>{__("thread-leaderboards.title")}</Title>
        {renderChips}
        {renderContent}
        <Button title={__("thread-leaderboards.modal.button")} onClick={() => setShowHowModal(true)} type={"clear"} />
        {renderHowModal}
    </div>
}
export default connect(mapStateToProps, mapDispatchToProps)(ThreadLeaderboards);